import React, { useState, useCallback } from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { __ } from '../../Lang.js';
import FeatureCoachmark from './FeatureCoachmark';

// use localStorage.removeItem('seen_personal_use_coachmark'); to reset for debugging
const SEEN_KEY = 'seen_personal_use_coachmark';

// Prevents more than one badge per page-load from auto-opening the coachmark
let coachmarkClaimedThisPage = false;

const PersonalUseBadge = ({ badgeClass = 'video-card__badge video-card__badge--personal', coachmark = false }) => {
    // Only the first instance on the page claims coachmark ownership
    const [isCoachmarkOwner] = useState(() => {
        if (coachmark && !coachmarkClaimedThisPage && !localStorage.getItem(SEEN_KEY)) {
            coachmarkClaimedThisPage = true;
            return true;
        }
        return false;
    });

    const [anchorEl, setAnchorEl] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const callbackRef = useCallback(node => {
        if (node) setAnchorEl(node);
    }, []);

    const handleClick = () => {
        // After the coachmark has been dismissed (OK clicked), badge click re-opens the info
        if (localStorage.getItem(SEEN_KEY)) {
            setPopoverOpen(prev => !prev);
        }
    };

    const body = (
        <>
            {__('This content is for personal use only.')}{' '}
            <a
                href={__('https://www.msia.org/customer-center-usage-guidelines')}
                target="_blank"
                rel="noopener noreferrer"
            >
                {__('Click here')}
            </a>{' '}
            {__('to learn more about personal use video.')}
        </>
    );

    return (
        <>
            <span
                ref={callbackRef}
                className={badgeClass}
                onClick={handleClick}
                style={{ cursor: 'pointer' }}
            >
                {__('Personal Use')}
            </span>
            {isCoachmarkOwner && anchorEl && (
                <FeatureCoachmark
                    anchorEl={anchorEl}
                    storageKey={SEEN_KEY}
                    title={__('Personal Use')}
                    body={body}
                    placement="bottom-start"
                />
            )}
            <Popover
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={() => setPopoverOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{ elevation: 2 }}
            >
                <Typography sx={{ p: 1.5, fontSize: '0.8rem', maxWidth: 260 }}>
                    {body}
                </Typography>
            </Popover>
        </>
    );
};

export default PersonalUseBadge;
